/* eslint-disable */
export default {
  flipHeader: 'Voltear llamada a…',
  flip: 'Transferir',
  complete: 'Completar Flip',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
